import * as z from 'zod'

import {
  investorList,
  markList,
  optionalText,
  requiredAmount,
  requiredDate,
  requiredText,
  tagList,
  withInvestors,
} from '../utils/schema'

export const privateSecuritySchema = withInvestors(
  z.object({
    assetType: requiredText('Say what kind of asset this is'),
    assetName: requiredText('Name this asset'),
    description: optionalText(),
    amount: requiredAmount('Enter the cost of the investment'),
    date: requiredDate('Enter the date of the investment'),
    currency: optionalText(),
    /*
     * The cost split across more than one entity — see WizardInvestor. Same
     * split machinery as PrivateFundSubscribeAndCommit's own `investors`:
     * share, percent, InvestorAllocationBar, "Split evenly". The assistant
     * may suggest a real split here when the sentence states one, same as
     * that sibling flow — but unlike it, is never required to: a read-seeded
     * row can still land unsized, same as a manual entry (see
     * `seedInvestors`).
     */
    investors: investorList(),
    prices: markList(),
    tags: tagList(),
  }),
)

export type PrivateSecurityValues = z.infer<typeof privateSecuritySchema>
